/*
 * Banners Messages
 *
 */
import { defineMessages } from 'react-intl';

export const scope = 'app.components.Banners';

export default defineMessages({
  offers: {
    id: `${scope}.offers`,
    defaultMessage: 'Vuoi creare un nuovo preventivo, ma hai bisogno di aiuto?',
    anchorTarget:
      'https://static.ideal-rent.com/guides/guida_veloce_offerte.pdf',
    anchorMessage: 'Consulta la nostra guida veloce.',
  },
  sponsor: {
    id: `${scope}.sponsor`,
    defaultMessage: 'Il tuo cliente vuole vendere la sua auto prima di passare al Noleggio? ',
    anchorTarget:
      'https://lp.ideal-rent.com/valutazione-auto',
    anchorMessage: 'Scopri il suo valore!',
  },
});
